import React from 'react';
import { useT } from '@/lib/i18n';
import { LegalLayout } from '@/components/legal/LegalLayout';

const Terms = () => {
  const { lang } = useT();
  const fr = (
    <>
      <h2>Article 1 — Objet</h2>
      <p>Les présentes Conditions Générales d&apos;Utilisation et de Vente (CGU/CGV) régissent l&apos;utilisation du service <strong>HighlightAI</strong>, plateforme SaaS de génération automatique de clips vidéo viraux par intelligence artificielle.</p>

      <h2>Article 2 — Acceptation</h2>
      <p>Toute création de compte vaut acceptation pleine et entière des présentes CGU/CGV. Si vous n&apos;acceptez pas ces conditions, vous ne devez pas utiliser le service.</p>

      <h2>Article 3 — Compte utilisateur</h2>
      <p>Vous êtes responsable de la confidentialité de vos identifiants. Vous garantissez que les informations fournies lors de l&apos;inscription sont exactes et à jour. L&apos;usage du service est limité aux personnes de plus de 16 ans.</p>

      <h2>Article 4 — Abonnements et tarifs</h2>
      <p>HighlightAI propose plusieurs formules d&apos;abonnement :</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>Gratuit</strong> : usage limité, filigrane, qualité 720p</li>
        <li><strong>Créateur (19$/mois)</strong> : uploads illimités, export HD 1080p sans filigrane, import depuis URL, sous-titres multilingues, traitement prioritaire</li>
        <li><strong>Studio (49$/mois)</strong> : tout du plan Créateur + fonctionnalités avancées</li>
      </ul>
      <p>Les paiements sont traités par <strong>Stripe</strong>. Les prix sont indiqués en dollars US (USD) et hors taxes applicables.</p>

      <h2>Article 5 — Durée et résiliation</h2>
      <p>Les abonnements sont conclus pour une durée d&apos;un mois, renouvelable tacitement. Vous pouvez résilier à tout moment depuis votre tableau de bord. La résiliation prend effet à la fin de la période en cours, sans remboursement prorata temporis.</p>

      <h2>Article 6 — Droit de rétractation</h2>
      <p>Conformément à l&apos;article L.221-28 du Code de la consommation, vous renoncez expressément à votre droit de rétractation dès l&apos;activation du service, le contenu numérique étant fourni immédiatement.</p>

      <h2>Article 7 — Usage acceptable</h2>
      <p>Vous vous engagez à ne pas uploader de contenu :</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Violant les droits d&apos;auteur d&apos;un tiers sans autorisation</li>
        <li>À caractère haineux, illégal, diffamatoire ou pornographique</li>
        <li>Contenant des malwares ou destiné au phishing</li>
      </ul>
      <p>HighlightAI se réserve le droit de suspendre tout compte en infraction sans préavis ni remboursement.</p>

      <h2>Article 8 — Propriété du contenu</h2>
      <p>Vous conservez l&apos;intégralité des droits sur vos vidéos uploadées et sur les clips générés. HighlightAI dispose uniquement d&apos;une licence non-exclusive pour traiter et stocker votre contenu durant la durée du service.</p>

      <h2>Article 9 — Limitation de responsabilité</h2>
      <p>HighlightAI est fourni « tel quel ». Nous ne garantissons pas que les clips générés correspondent à une attente subjective. Notre responsabilité est limitée au montant payé sur les 3 derniers mois.</p>

      <h2>Article 10 — Modifications</h2>
      <p>HighlightAI se réserve le droit de modifier les présentes CGU/CGV. Les utilisateurs sont notifiés par email 30 jours avant l&apos;entrée en vigueur des nouvelles conditions.</p>

      <h2>Article 11 — Droit applicable et litiges</h2>
      <p>Les présentes CGU/CGV sont soumises au droit français. Tout litige sera soumis aux tribunaux français compétents, après tentative de résolution amiable préalable.</p>
    </>
  );
  const en = (
    <>
      <h2>1. Purpose</h2>
      <p>These Terms of Service govern your use of <strong>HighlightAI</strong>, a SaaS platform for AI-powered viral clip generation.</p>
      <h2>2. Acceptance</h2>
      <p>Creating an account constitutes full acceptance of these Terms. If you don&apos;t agree, do not use the service.</p>
      <h2>3. User account</h2>
      <p>You are responsible for keeping your credentials confidential. You must be at least 16 years old. Information provided must be accurate and up to date.</p>
      <h2>4. Subscriptions & pricing</h2>
      <p>HighlightAI offers Free, Creator ($19/mo), and Studio ($49/mo) plans. Payments are processed by <strong>Stripe</strong>. Prices in USD, excluding applicable taxes.</p>
      <h2>5. Term & cancellation</h2>
      <p>Subscriptions are monthly, auto-renewing. Cancel anytime from your dashboard. Effective at the end of current billing period, no prorated refund.</p>
      <h2>6. Right of withdrawal</h2>
      <p>By activating the service, you waive your statutory right of withdrawal (digital content delivered immediately).</p>
      <h2>7. Acceptable use</h2>
      <p>Do not upload copyrighted material without rights, hateful/illegal/defamatory/pornographic content, malware, or phishing material. Violations result in immediate suspension without refund.</p>
      <h2>8. Content ownership</h2>
      <p>You retain all rights to uploaded videos and generated clips. HighlightAI holds only a non-exclusive license to process and store your content for the service duration.</p>
      <h2>9. Limitation of liability</h2>
      <p>HighlightAI is provided &quot;as-is&quot;. We do not guarantee subjective satisfaction with generated clips. Liability capped at the amount paid in the last 3 months.</p>
      <h2>10. Changes</h2>
      <p>HighlightAI may update these Terms. Users are notified by email 30 days before changes take effect.</p>
      <h2>11. Governing law</h2>
      <p>These Terms are governed by French law. Disputes fall under French courts after attempted amicable resolution.</p>
    </>
  );
  return <LegalLayout titleFr="Conditions Générales d'Utilisation et de Vente" titleEn="Terms of Service">{lang === 'fr' ? fr : en}</LegalLayout>;
};

export default Terms;
